import { ChainList } from '@/components/chains/ChainList';
import { AttachmentDecisionBanner } from '@/components/chains/AttachmentDecisionBanner';

export function ChainsPage() {
  return (
    <div className="space-y-6">
      <AttachmentDecisionBanner />
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Trade Chains</h1>
        <p className="text-sm text-gray-500 mt-1">
          View and manage all your options trades
        </p>
      </div>

      <ChainList />
    </div>
  );
}
